const DEVICE_ID_STORAGE_KEY = "qylmox_device_id";

function generateDeviceId() {
  const randomPart = Math.random().toString(36).slice(2, 10);
  return `web-${Date.now().toString(36)}-${randomPart}`;
}

export function getOrCreateClientDeviceId() {
  if (typeof window === "undefined") return "server-render";

  try {
    const existing = localStorage.getItem(DEVICE_ID_STORAGE_KEY);
    if (existing) return existing;
    const next = generateDeviceId();
    localStorage.setItem(DEVICE_ID_STORAGE_KEY, next);
    return next;
  } catch (error) {
    return generateDeviceId();
  }
}
